<template>
    <div id="reportSmartSearchResults" class="search-results-container">
        <div class="feature-area-wrapper">
            <div class="feature-area feature-area-compact">
                <div class="pageHeader">
                    <div class="search-results-section">
                        <div class="title-container">

                        </div>
                    </div>
                </div>
                <navigationTabs />
            </div>
        </div>

        <div class="searchResults">
            <div class="adv-results-container" ref="resultsContainer">
                <facets class=""  ref="facets"/>
                <div class="tableContainer">
                    <dataTable class="dataTable" :table="projectListTable" fromPage="searchResults"  ref="dataTable" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex';
import dataTable from '@/components/global/dataTable.vue';
import facets from '@/components/global/facets.vue';
import globalMixins from '@/globalMixins';
import projectListMixins from '@/projectListMixins';
import searchCriteria from '@/components/global/searchCriteria.vue';
import navigationTabs from '@/components/global/navigationTabs.vue';

export default {
    name: 'reportSmartSearch',
    mixins: [globalMixins, projectListMixins],
    components: {
      dataTable,
      facets,
      searchCriteria,
      navigationTabs
    },
    computed: {
        ...mapGetters([
            'searchMeta',
            'searchResults',
            'searchCriteria',
        ]),
    },
    data: function () {
        return {
            serverless: false
        };
    },
    mounted () {
        window.scrollTo(0, 0);

        this.getProjectsForSmartSearchQuery();
    },
    methods: {
        ...mapActions([
            'setSearchCriteria'
        ]),
        getProjectsForSmartSearchQuery () {
            this.loading = true;
            this.$store.state.searchCriteria['smart_search_text'] = this.$route.params.queryString;
			
			gtag('event','Click', {
				'event_category': 'Report Home',
				'event_label': 'Quick Search - Report',
				'value': 'Quick Search - Report'
			});	

            this.clearSearchResults({resetFacets: true});

            this.setSearchType('Smart');
            this.getProjectsForReportSmartSearch(this.handleSmartSearchProjectListing);
        },
        handleSmartSearchProjectListing (data) {
            var profileId = this.$route.params.pi_id,
                dataResults,
                j,
                recordFound = false;

            if (data && data.meta && data.results) {
                this.setSearchMeta(data.meta);
                this.setSearchResults(data.results);

                this.$router.push('/search/' + data.meta.search_id + '/projects');
            } else {
                // this.setErrorMessage('Error retrieving data, please try again in a few minutes', 8000);
            }
        },
    }
}
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';

    .title-container{
        display: inline-block;
        font-size: 28px;
        .page-title {
            font-size: 28px;
            margin-bottom: 5px;
            margin-right: 15px;
        }
    }

    .sub-title {
        font-size: 16px;
    }

    .widget-button-criteria {
        padding: 3px 10px 1px;
        border-radius: 15px;
        font-weight: 700;

        span {
            display: inline-block;
            margin-right: 5px;
        }

        .widget-button-icon {
            margin-top: -2px;
            margin-right: 6px;
            $icon-size: 13px;
            width: $icon-size;
            height: $icon-size;
            fill: #555;
            transition: 0.3s;
        }

        &:hover,
        &:focus {
            .widget-button-icon {
                fill: #fff;
            }
        }
    }

    .feature-area {
        .search-results-section {
            display: inline-block;
            width: 100%;
        }
    }

    .sort-note {
        position: absolute;
        right: 10px;
        font-size: 16px;
        padding-top: 7px;
        span {
            font-weight: bold;
        }

        @media screen and (max-width: $screen-md-min) {
            position: relative;
            margin-left: 10px;
            margin-bottom: 10px;
        }
    }

</style>